import React, { createContext, PropsWithChildren } from 'react';

/**
 * Provides the active table's gameID to all child components.
 * Each Game instance wraps its tree with this context so components
 * know which table's state to read from Redux.
 */
export const TableIdContext = createContext<string>('');

type TableIdProviderProps = PropsWithChildren & {
  gameID: string;
};

export const TableIdProvider = ({ gameID, children }: TableIdProviderProps) => {
  return <TableIdContext.Provider value={gameID}>{children}</TableIdContext.Provider>;
};
